import { FETCH_QUOTES, NEW_QUOTE } from '../constants';

export const fetchQuotes = () => dispatch => {
  fetch(
    'https://res.cloudinary.com/romanofun/raw/upload/v1593723203/quotes_oehawa.json'
  )
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      console.log('ok');
      return response.json();
    })
    .then(data => {
      //   this.setState({ loading: false, error: false, posts: data });
      dispatch({ type: FETCH_QUOTES, payload: data.quotes });
    })
    .catch(error => {
      console.log(error);
      //   this.setState({ loading: false, error: true });
    });
};

export const newQuote = randomNo => ({
  type: NEW_QUOTE,
  payload: randomNo,
});
